module.exports = __webpack_public_path__ + "img/lastschrift.260e733.svg";